import {actionTypes} from '../const';
const initialState = {
    authenticated:false,
    role:'',
    id_token:'',
    name:'',
    employeeID:'',
    loginProgress:false,
    loginErrMsg:false,
    impersonateUserId:'',
    activeMenus : [],
    isOnDutyLoggedin : false,
    editModeOnTime : '',
    isOnDutyLoggedinForToday : false,
    server_time : '',
    publicClient:undefined,
    userName:'',
    isAzureError:false,
    azureErrMsg:'',
    homePath:'',
    api_token:'',
    isSystemAdmin:false,
    userId:''
}

const auth = (state = initialState, action) => {
    switch (action.type) {
        
        case actionTypes.LOGIN_SUCCESS:{
            
            return Object.assign({}, state, {
                    authenticated:action.authenticated,
                    role:action.role,
                    id_token: action.id_token,
                    name:action.name,
                    employeeID:action.employeeID,
                    impersonateUserId:action.impersonateUserId,
                    activeMenus : action.activeMenus,
                    api_token: action.api_token,
                    isSystemAdmin:action.isSystemAdmin,
                    userId:action.userId
                });
        }
        case actionTypes.LOGIN_ERROR:{
            return Object.assign({}, state, {
                loginErrMsg:action.loginErrMsg,
                loginProgress:action.loginProgress
            });
        }
        case actionTypes.LOGIN_PROGRESS:{
            
            return Object.assign({}, state, {
                loginProgress:action.loginProgress
            });
        }
        case actionTypes.LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                authenticated:action.authenticated,
                role:action.role,
                id_token: action.id_token,
                name:action.name,
                employeeID:action.employeeID,
                loginProgress:false,
                loginErrMsg:false,
                impersonateUserId:action.impersonateUserId,
                publicClient:undefined,
                userName:''
            });
        case actionTypes.OFFDUTY_CHECK:{
            return Object.assign({}, state, {
                isOnDutyLoggedin:action.isOffDutyLoggedin,
                editModeOnTime : action.editModeOnTime
            });
        }
        case actionTypes.OFFDUTY_CHECK_FOR_TODAY:{
            return Object.assign({}, state, {
                isOnDutyLoggedinForToday:action.isOnDutyLoggedinForToday
            });
        }
        case actionTypes.UPDATE_SERVER_TIME:{
            return Object.assign({}, state, {
                server_time:action.server_time
            });
        }
        case actionTypes.UPDATE_ACTIVE_MENU:{
            return Object.assign({}, state, {
                activeMenus:action.active_menus
            });
        }
        case actionTypes.SET_AZURE_MSAL:{
            return Object.assign({}, state, {
                publicClient:action.msal
            });
        }
        case actionTypes.SET_AZURE_USER_ACC:{
            return Object.assign({}, state, {
                userName:action.user
            });
        }
        case actionTypes.SET_HOME_PATH:{

            
            return Object.assign({}, state, {
                authenticated:true,
                homePath:action.path
            });
        }
        case actionTypes.SET_AZURE_ERROR:{
            return Object.assign({}, state, {
                isAzureError:true,
                azureErrMsg:action.message
            });
        }
        case actionTypes.IMPERSONATE_LOGIN_START:
            return Object.assign({}, state, {
                authenticated:action.authenticated,
                role:action.role,
                id_token: action.id_token,
                name:action.name,
                employeeID:action.employeeID,
                loginProgress:false,
                loginErrMsg:false,
                impersonateUserId:action.impersonateUserId,
                publicClient:undefined,
                userName:''
            });
        default:
            return state;
    }
}
export default auth